const API_URL = process.env.REACT_APP_BACKEND_URL;
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

const genId = () =>
  (window.crypto && window.crypto.randomUUID)
    ? window.crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

const getId = (storage, key) => {
  try {
    let v = storage.getItem(key);
    if (!v) {
      v = genId();
      storage.setItem(key, v);
    }
    return v;
  } catch {
    return '';
  }
};

export const initGA = () => {
  if (!GA_ID || window.__gaLoaded) return;
  window.__gaLoaded = true;
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { send_page_view: false });
};

const getUtm = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const fresh = {
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
    };
    if (fresh.utm_source) {
      sessionStorage.setItem('mt_utm', JSON.stringify(fresh));
      return fresh;
    }
    const saved = sessionStorage.getItem('mt_utm');
    return saved ? JSON.parse(saved) : fresh;
  } catch {
    return { utm_source: '', utm_medium: '', utm_campaign: '' };
  }
};

export const trackPageView = (path) => {
  if (path.startsWith('/admin')) return;
  const visitor_id = getId(localStorage, 'mt_visitor_id');
  const session_id = getId(sessionStorage, 'mt_session_id');
  fetch(`${API_URL}/api/analytics/track`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      event_type: 'page_view',
      path,
      referrer: document.referrer || '',
      visitor_id,
      session_id,
      ...getUtm(),
    }),
  }).catch(() => {});
  if (window.gtag && GA_ID) {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }
};

export const trackConversion = (name, params = {}) => {
  try {
    if (window.gtag && GA_ID) window.gtag('event', name, params);
  } catch { /* gtag blocked or unavailable — analytics must never break the app */ }
};
